define(['core/browser-storage'],
    function (storage) {
        return {
            init: function () {
                let campaignId = document.querySelector(".nps-success").dataset.campaignId;

                if(campaignId) {
                    storage.setItem("last-visited-campaign", campaignId);
                }
                
                storage.removeItem("conf-email-img");
            }
        }
    }
);
